export * from './target-room.component';
